// import SVG from "react-inlinesvg";
import { Box, Modal } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { MdOutlineKeyboardAlt } from "react-icons/md";
import { BoxStyled } from "styledComponents/component";
// import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import { useEffect, useState } from "react";
import Keyboard from "react-simple-keyboard";

let useStyles = makeStyles((theme) => ({
  input: {
    width: "100%",
    minHeight: 35,
  },
}));

export default function Index({
  setIndexChild,
  formik,
  isSuccess,
  setisError,
  isError,
  setIsSuccess,
  getInputClasses,
  title,
  loading,
}) {
  let classes = useStyles();
  const [showNewUsername, setShowNewUsername] = useState(false);
  const [inputNewUsername, setInputNewUsername] = useState("");
  const [showKeyEmail, setShowKeyEmail] = useState(false);
  const [showKeyPass, setShowKeyPass] = useState(false);
  const [layoutName, setLayoutName] = useState("default");
  const [inputEmail, setInputEmail] = useState("");
  const [inputPass, setInputPass] = useState("");
  const onChange = (newInput) => {
    if (showKeyEmail) {
      return setInputEmail(newInput);
    } else if (showKeyPass) {
      return setInputPass(newInput);
    } else if (showNewUsername) {
      return setInputNewUsername(newInput);
    }
  };

  const onKeyPress = (button) => {
    if (button === "{shift}" || button === "{lock}") handleShift();
  };

  const handleShift = () => {
    setLayoutName((prevLayout) =>
      prevLayout === "default" ? "shift" : "default",
    );
  };

  useEffect(() => {
    formik.setFieldValue("password", inputEmail);
  }, [inputEmail]);
  useEffect(() => {
    formik.setFieldValue("cPassword", inputPass);
  }, [inputPass]);
  useEffect(() => {
    formik.setFieldValue("new_username", inputNewUsername);
  }, [inputNewUsername]);
  return (
    <>
      <BoxStyled minHeight={200}>
        <div>
          <h1 className="pr-3 mb-3 mt-2 text-[#646464] text-lg">{title}</h1>
        </div>

        <form className=" card-custom h-100" onSubmit={formik.handleSubmit}>
          {/* begin::Form */}
          <div className="form">
            <div className="card-body">
              {/* begin::Alert */}
              {isError && (
                <div
                  className="alert alert-custom alert-light-danger fade show mb-10"
                  role="alert"
                >
                  <div className="alert-icon"></div>
                  <div className="alert-text font-weight-bold">
                    متاسفانه انجام نشد
                  </div>
                  <div
                    className="alert-close"
                    onClick={() => setisError(false)}
                  >
                    <button
                      type="button"
                      className="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">
                        <i className="ki ki-close"></i>
                      </span>
                    </button>
                  </div>
                </div>
              )}

              {isSuccess && (
                <div
                  className="alert alert-custom alert-light-success fade show mb-10"
                  role="alert"
                >
                  <div className="alert-icon">
                    <span className="svg-icon svg-icon-3x svg-icon-danger">
                      {/* <CheckCircleIcon color="primary" />{" "} */}
                    </span>
                  </div>
                  <div className="alert-text font-weight-bold">
                    با موفقیت انجام شد.
                  </div>
                  <div
                    className="alert-close"
                    onClick={() => setisError(false)}
                  >
                    <button
                      type="button"
                      className="close"
                      data-dismiss="alert"
                      aria-label="Close"
                      onClick={() => setIsSuccess(false)}
                    >
                      <span aria-hidden="true">
                        <i className="ki ki-close"></i>
                      </span>
                    </button>
                  </div>
                </div>
              )}

              <div className="W-full flex flex-col md:flex-row mb-4 md:items-center">
                <div className="pr-0 md:pr-10 text-sm ml-28 md:w-[150px] w-full whitespace-nowrap">
                  نام کاربری
                </div>
                {showNewUsername && (
                  <Modal
                    sx={{
                      "& .muirtl-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
                        backgroundColor: "transparent",
                      },
                    }}
                    open={showNewUsername}
                    onClose={() => {
                      setShowNewUsername(false);
                    }}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                  >
                    <div
                      style={{
                        display: "flex",
                        backgroundColor: "#ffffff",
                        zIndex: 100,
                        borderRadius: 5,
                        position: "absolute",
                        top: "76%",
                        left: "50%",
                        transform: "translate(-50%, -90%)",
                        outline: 0,
                        border: 0,
                        boxShadow: 24,
                        maxWidth: "100%",
                        width: "auto",
                        maxHeight: "80vh",
                        overflowY: "auto",
                      }}
                    >
                      <div style={{ direction: "ltr" }}>
                        <Keyboard
                          input={inputNewUsername}
                          layoutName={layoutName}
                          onChange={onChange}
                          onKeyPress={onKeyPress}
                        />
                      </div>
                    </div>
                  </Modal>
                )}
                <div className="w-full md:w-[350px] lg:w-[200px] xl:w-[330px] 2xl:w-[380px]  rounded-lg min-h-[50px] text-gray-400 flex items-center flex-col relative">
                  <input
                    placeholder="نام کاربری"
                    className={`${
                      classes["input"]
                    } border border-gray-300   h-[50px] pr-2  rounded-lg ${getInputClasses(
                      "new_username ",
                    )}`}
                    name="new_username"
                    {...formik.getFieldProps("new_username")}
                    onChange={(event) => {
                      formik.setFieldValue(
                        "new_username",
                        event.target.value.replace(/\s/g, ""),
                      );
                    }}
                  />
                  <div className="absolute top-[13px] left-4 text-gray-600 cursor-pointer">
                    <MdOutlineKeyboardAlt
                      onClick={() => setShowNewUsername((prev) => !prev)}
                      size={25}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                  {formik.touched.new_username && formik.errors.new_username ? (
                    <div className="invalid-feedback text-xs text-red-500 mt-1">
                      {formik.errors.new_username}
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="W-full flex flex-col md:flex-row mb-4 md:items-center">
                <div className="pr-0 md:pr-10 text-sm ml-28 md:w-[150px] w-full whitespace-nowrap">
                  رمز عبور جدید
                </div>
                {showKeyEmail && (
                  <Modal
                    sx={{
                      "& .muirtl-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
                        backgroundColor: "transparent",
                      },
                    }}
                    open={showKeyEmail}
                    onClose={() => {
                      setShowKeyEmail(false);
                    }}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                  >
                    <div
                      style={{
                        display: "flex",
                        backgroundColor: "#ffffff",
                        zIndex: 100,
                        borderRadius: 5,
                        position: "absolute",
                        top: "76%",
                        left: "50%",
                        transform: "translate(-50%, -90%)",
                        outline: 0,
                        border: 0,
                        boxShadow: 24,
                        maxWidth: "100%",
                        width: "auto",
                        maxHeight: "80vh",
                        overflowY: "auto",
                      }}
                    >
                      <div style={{ direction: "ltr" }}>
                        <Keyboard
                          input={inputEmail}
                          layoutName={layoutName}
                          onChange={onChange}
                          onKeyPress={onKeyPress}
                        />
                      </div>
                    </div>
                  </Modal>
                )}
                <div className="w-full md:w-[350px] lg:w-[200px] xl:w-[330px] 2xl:w-[380px]  rounded-lg min-h-[50px] text-gray-400 flex items-center flex-col relative">
                  <input
                    type="password"
                    placeholder="رمز عبور جدید"
                    className={`${
                      classes["input"]
                    } border border-gray-300   h-[50px] pr-2  rounded-lg ${getInputClasses(
                      "password",
                    )}`}
                    name="password"
                    {...formik.getFieldProps("password")}
                    onChange={(event) => {
                      formik.setFieldValue(
                        "password",
                        event.target.value.replace(/\s/g, ""),
                      );
                    }}
                  />
                  <div className="absolute top-[13px] left-4 text-gray-600 cursor-pointer">
                    <MdOutlineKeyboardAlt
                      onClick={() => setShowKeyEmail((prev) => !prev)}
                      size={25}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                  {formik.touched.password && formik.errors.password ? (
                    <div className="invalid-feedback text-xs text-red-500 mt-1">
                      {formik.errors.password}
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="W-full flex flex-col md:flex-row mb-4 md:items-center">
                <div className="pr-0 md:pr-10 text-sm ml-28 md:w-[150px] w-full whitespace-nowrap">
                  تائید رمز عبور
                </div>
                {showKeyPass && (
                  <Modal
                    sx={{
                      "& .muirtl-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
                        backgroundColor: "transparent",
                      },
                    }}
                    open={setShowKeyPass}
                    onClose={() => {
                      setShowKeyPass(false);
                    }}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                  >
                    <div
                      style={{
                        display: "flex",
                        backgroundColor: "#ffffff",
                        zIndex: 100,
                        borderRadius: 5,
                        position: "absolute",
                        top: "86%",
                        left: "50%",
                        transform: "translate(-50%, -110%)",
                        outline: 0,
                        border: 0,
                        boxShadow: 24,
                        maxWidth: "100%",
                        width: "auto",
                        maxHeight: "80vh",
                        overflowY: "auto",
                      }}
                    >
                      {" "}
                      <div style={{ direction: "ltr" }}>
                        <Keyboard
                          input={inputEmail}
                          layoutName={layoutName}
                          onChange={onChange}
                          onKeyPress={onKeyPress}
                        />
                      </div>
                    </div>
                  </Modal>
                )}
                <div className="w-full md:w-[350px] lg:w-[200px] xl:w-[330px] 2xl:w-[380px]  rounded-lg min-h-[50px] text-gray-400 flex items-center flex-col relative ">
                  <input
                    type="password"
                    placeholder="تائید رمز عبور"
                    className={`${
                      classes["input"]
                    } border border-gray-300 h-[50px] pr-2 rounded-lg  ${getInputClasses(
                      "cPassword",
                    )}`}
                    name="cPassword"
                    {...formik.getFieldProps("cPassword")}
                  />
                  <div className="absolute top-[13px] left-4 text-gray-600 cursor-pointer">
                    <MdOutlineKeyboardAlt
                      onClick={() => setShowKeyPass((prev) => !prev)}
                      size={25}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                  {formik.touched.cPassword && formik.errors.cPassword ? (
                    <div className="invalid-feedback text-xs text-red-500">
                      {formik.errors.cPassword}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          <Box>
            <Box
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 20,
              }}
            >
              <button
                className={`border border-primary text-primary rounded-md py-1 px-5 ${
                  !loading && "hover:text-white hover:bg-primary"
                } relative`}
                type="submit"
                disabled={loading}
                // disabled={
                //     formik.isSubmitting || (formik.touched && !formik.isValid)
                //   }
              >
                {loading && (
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-primary absolute top-2 left-14"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                )}
                ثبت درخواست
              </button>
              <button
                className={
                  "border border-red-600 py-1 px-5 rounded-md text-red-600 mr-2 hover:bg-red-600 hover:text-white"
                }
                onClick={() => setIndexChild(0)}
              >
                لغو
              </button>
            </Box>
          </Box>
        </form>
      </BoxStyled>
    </>
  );
}
